module.exports = __webpack_public_path__ + "img/dinflow.0aedaecc.svg";